export const classes = {
  card: 'w-[450px] relative flex items-center gap-4 p-3 border border-white hover:border-orange-3 shadow-dialog',
  icon: 'size-12',
  title: 'flex justify-between items-start gap-2',
  closeButton: 'p-1',
  content: 'grow flex flex-col gap-2',
  name: 'text-grey-8 dark:text-mauve-1 font-medium text-sm text-left hover:underline cursor-pointer outline-none mt-1',
  description:
    'text-sm text-grey-6 dark:text-mauve-3 flex gap-2 justify-between',
};
